export const validateUrl = (url: string): boolean => {
  if (!url || url.trim() === "") return true; // Empty is valid (optional field)
  
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
  } catch {
    return false;
  }
};

export const validateSocialUrl = (url: string, platform: string): string | null => {
  if (!url || url.trim() === "") return null;
  
  if (!validateUrl(url)) {
    return "Please enter a valid URL starting with http:// or https://";
  }
  
  const platformDomains: Record<string, string[]> = {
    facebook: ["facebook.com", "fb.com"],
    twitter: ["twitter.com", "x.com"],
    linkedin: ["linkedin.com"],
    instagram: ["instagram.com"],
    tiktok: ["tiktok.com"],
    youtube: ["youtube.com", "youtu.be"],
    pinterest: ["pinterest.com"],
  };
  
  const domains = platformDomains[platform.toLowerCase()];
  if (domains) {
    const urlObj = new URL(url);
    const isValidDomain = domains.some(domain => 
      urlObj.hostname === domain || urlObj.hostname.endsWith(`.${domain}`)
    );
    
    if (!isValidDomain) {
      return `Please enter a valid ${platform} URL (e.g., https://${domains[0]}/yourprofile)`;
    }
  }
  
  return null;
};
